export default __webpack_public_path__ + "static/media/logo.4d8c9682.svg";